import { useNavigate } from "react-router-dom";
import { Minus, Plus, X } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { img, inr } from "@/lib/api";

export function CartDrawer() {
  const { items, setQty, total, open, setOpen } = useCart();
  const nav = useNavigate();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="bg-[#0B0907] border-l border-[#D4AF37]/20 text-[#F5EFE6] w-full sm:max-w-md flex flex-col" data-testid="cart-drawer">
        <SheetHeader>
          <SheetTitle className="font-display tracking-[0.2em] text-[#F3E5AB]">YOUR CART</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto scrollbar-thin mt-6 space-y-5">
          {items.length === 0 && <p className="font-serif-it text-xl text-[#A89F91]" data-testid="cart-empty">Your cart awaits its first story.</p>}
          {items.map((i) => (
            <div key={i.id} className="flex gap-4" data-testid={`cart-item-${i.id}`}>
              <img src={img(i.image_url)} alt={i.name} className="h-24 w-20 object-cover rounded" />
              <div className="flex-1 min-w-0">
                <p className="font-display text-sm truncate">{i.name}</p>
                <p className="font-serif-it text-[#A89F91]">{i.origin}</p>
                <div className="flex items-center gap-3 mt-2">
                  <button onClick={() => setQty(i.id, i.qty - 1)} className="p-1 border border-[#D4AF37]/30 rounded-full" data-testid={`cart-dec-${i.id}`}><Minus className="h-3 w-3" /></button>
                  <span className="text-sm" data-testid={`cart-qty-${i.id}`}>{i.qty}</span>
                  <button onClick={() => setQty(i.id, i.qty + 1)} className="p-1 border border-[#D4AF37]/30 rounded-full" data-testid={`cart-inc-${i.id}`}><Plus className="h-3 w-3" /></button>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm text-[#F3E5AB]">{inr(i.price * i.qty)}</p>
                <button onClick={() => setQty(i.id, 0)} className="mt-2 text-[#6E6558] hover:text-[#E06D3B]" data-testid={`cart-remove-${i.id}`}><X className="h-4 w-4" /></button>
              </div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-[#D4AF37]/20 pt-5 space-y-4">
            <div className="flex justify-between font-display">
              <span>Subtotal</span>
              <span className="text-[#F3E5AB]" data-testid="cart-subtotal">{inr(total)}</span>
            </div>
            <button
              onClick={() => { setOpen(false); nav("/checkout"); }}
              className="btn-glow w-full rounded-full bg-[#D4AF37] text-[#0B0907] py-3 font-semibold tracking-wide hover:bg-[#F3E5AB]"
              data-testid="cart-checkout-button"
            >
              Proceed to checkout
            </button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
